import { render, staticRenderFns } from "./TranscriptLayer.vue?vue&type=template&id=d6fe42d4&scoped=true&"
import script from "./TranscriptLayer.vue?vue&type=script&lang=js&"
export * from "./TranscriptLayer.vue?vue&type=script&lang=js&"
import style0 from "./TranscriptLayer.vue?vue&type=style&index=0&id=d6fe42d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fe42d4",
  null
  
)

export default component.exports